import { render } from "./BookViewClothes.vue?vue&type=template&id=70c22320&scoped=true"
import script from "./BookViewClothes.vue?vue&type=script&lang=js"
export * from "./BookViewClothes.vue?vue&type=script&lang=js"

import "./BookViewClothes.vue?vue&type=style&index=0&id=70c22320&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70c22320"

export default script